<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller" />

    <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
            <div class="col-lg-7 col-md-10">
              <h1 class="display-3 text-white">Asignación de Productos</h1>
              <p class="text-white mt-0 mb-5">Para comenzar, busca un cliente en el listado</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <SearchDealer :inputData.sync="filters.dealers" :options="options" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid mt--7">
      <my-spinner :loading="filters.selected.loading" />
      <div class="row" v-if="filters.dealers">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header bg-secondary">
              <div class="row">
                <div class="col-sm-9">
                  <h3 class="text-default m-0 mt-2">Listado de avisos</h3>
                </div>
                <div class="col-sm-3 d-flex" v-if="_showAdsResult || _searchActive">
                  <div class="form-group m-0">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="ni ni-zoom-split-in"></i>
                        </span>
                      </div>
                      <input
                        @keyup.enter="setSearch(true)"
                        v-model="filters.search"
                        class="form-control"
                        placeholder="Buscar por código"
                        type="number"
                      />
                    </div>
                  </div>
                  <div class="form-group m-0 ml-2" v-if="_searchActive">
                    <button
                      class="btn btn-secondary font-weight-normal"
                      @click="setSearch(false)"
                    >Limpiar</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table table-hover mb-0">
                  <thead class="bg-secondary">
                    <tr>
                      <th style="width: 80px;">ID</th>
                      <th>Vehículo</th>
                      <th class="text-right">Precio</th>
                      <th>Asignados</th>
                      <th style="width:250px">Productos disponibles</th>
                      <th v-if="actions.put || actions.post">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!filters.selected.loading && !_showAdsResult">
                      <td class="text-center" colspan="7">No hay avisos disponibles</td>
                    </tr>
                    <template v-else>
                      <tr
                        v-for="(item, indexAd) in filters.selected.dealer.ads"
                        :key="'keyAd'+indexAd"
                      >
                        <td class="text-muted">{{item.id}}</td>
                        <td>
                          <h5 class="font-weight-bold text-dark">
                            {{item.make}} {{item.model}} {{item.year}}
                            <br />
                            <small class="text-muted text-xs">
                              {{item.version}} | Patente:
                              <span
                                class="text-uppercase"
                              >{{ item.patente }}</span>
                            </small>
                          </h5>
                        </td>
                        <td class="text-right">{{item.price | formatCurrency}}</td>
                        <td class="text-center">
                          <span
                            class="text-center text-muted"
                            v-if="item.products && item.products.length == 0"
                          >--</span>
                          <template v-else>
                            <template v-for="(product, indexProduct) in item.products">
                              <span
                                :key="'keyActiveProduct'+product.code+indexProduct"
                                v-b-tooltip.hover
                                :title="product.details"
                                class="badge badge--product"
                                :class="getBadge(product.code)"
                              >{{product.caption}}</span>
                            </template>
                          </template>
                        </td>
                        <td>
                          <div class="form-group m-0" v-if="filters.selected.products.length > 0">
                            <select
                              class="form-control alternative --selectedProduct"
                              :id="'selectedProduct'+item.id"
                            >
                              <option value="0">Selecciona un producto</option>
                              <template
                                v-for="p in filters.selected.products.filter(item => item.id_cp_fk == 0)"
                              >
                                <option
                                  :key="'_cp_' + p.id_cp"
                                  :value="p.id_cp"
                                  :disabled="getOptionsProductList(item.products, p, true)"
                                >{{getProductCaption(p)}} {{getOptionsProductList(item.products, p, false)}}</option>
                              </template>
                            </select>
                          </div>
                          <span class="text-muted text-xs" v-else>No hay productos disponibles</span>
                        </td>
                        <td v-if="actions.put || actions.post">
                          <button
                            class="btn btn-secondary"
                            @click="setProductAsign(item)"
                            :disabled="filters.post.Dealeradvert == item.id"
                            type="button"
                          >
                            <b-spinner
                              variant="primary small mr-1"
                              label="Spinning"
                              v-if="filters.post.Dealeradvert == item.id"
                            ></b-spinner>
                            {{ filters.post.Dealeradvert == item.id ? 'Cargando..' : 'Asignar' }}
                          </button>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Dealer } from "./model";
import utils from "@/helpers/utils";
import Auth from "@/helpers/middleware";
import sysMsgs from "@/helpers/system.message";
import dealerServices from "@/services/dealers.services";
export default {
  name: "asignacionProductos",
  data() {
    return {
      controller: {
        title: "Operaciones",
        mainRouter: "/operaciones/avisos/asignacion-productos"
      },
      options: {
        active: true
      },
      actions: Auth.getActions(this.$route.name),
      user: Auth.getUser(),
      filters: {
        dealers: null,
        loading: false,
        loadingProducts: false,
        search: null,
        selected: {
          dealer: new Dealer(),
          ads: [],
          products: []
        },
        post: {
          Dealeradvert: null
        }
      }
    };
  },
  watch: {
    "filters.dealers": {
      deep: true,
      handler(data) {
        this.filters.selected.dealer = new Dealer();
        this.filters.selected.products = [];
        this.filters.search = null;
        if (data != null) {
          this.getAdverts(data.cod_cliente);
        }
      }
    }
  },
  computed: {
    _showAdsResult() {
      return (
        this.filters.selected.dealer.ads &&
        this.filters.selected.dealer.ads.length > 0
      );
    },
    _searchActive() {
      return this.filters.search;
    }
  },
  created() {},
  filters: {
    formatCurrency(str) {
      return utils.currency(str);
    },
    formatDateTime(str) {
      return utils.formatDateTime(str);
    }
  },
  methods: {
    getAdverts(cod_cliente) {
      let _self = this;
      _self.filters.selected.loading = true;
      dealerServices.asignacion
        .getAdverts(cod_cliente)
        .then(response => {
          _self.filters.selected.dealer = response.data;
          _self.filters.selected.ads = response.data.ads
            ? response.data.ads
            : [];
          _self.filters.selected.loading = false;
          _self.getProducts(cod_cliente);
        })
        .catch(error => {
          console.log("error", error);
          sysMsgs.getResponseMessage(error.response);
        })
        .finally(() => {
          _self.filters.selected.loading = false;
        });
    },
    getProducts(cod_cliente) {
      let _self = this;
      _self.filters.selected.loadingProducts = true;
      dealerServices.asignacion
        .getProducts(cod_cliente)
        .then(response => {
          _self.filters.selected.products = response.data;
          _self.filters.selected.loadingProducts = false;
        })
        .catch(error => {
          _self.filters.selected.products = [];
          //sysMsgs.getResponseMessage(error.response);
        })
        .finally(() => {
          _self.filters.selected.loadingProducts = false;
        });
    },
    setProductAsign(data) {
      let _self = this;
      let itemOutput ={... data};
      let productId = document.getElementById("selectedProduct" + itemOutput.id)
        .value;

      let product = this.filters.selected.products.filter(
        item => item.id_cp == productId || item.id_cp_fk == productId
      );

      if (!productId || productId == 0) {
        sysMsgs.getMessage("Debes seleccionar un Producto", "error");
        return false;
      } else if (
        product.find(item => item.id_cp == productId).used >=
        product.find(item => item.id_cp == productId).available
      ) {
        sysMsgs.getMessage("El producto no se encuentra disponible", "error");
        return false;
      }

      itemOutput.products = product.map(item => {
        item.user = _self.user.email;
        return item;
      });
      _self.filters.post.Dealeradvert = data.id;

      dealerServices.asignacion
        .setProducts(itemOutput)
        .then(response => {
          data.products = response.data.data.products;
          _self.getProducts(_self.filters.selected.dealer.id);
          document.getElementById("selectedProduct" + data.id).value = 0;
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
        })
        .finally((response) => {
          _self.filters.post.Dealeradvert = null;
          _self.filters.selected.loadingProducts = false;
        });
    },
    getBadge(code) {
      if (!code) return "";

      switch (code.toLowerCase().trim()) {
        case "topspot":
          return "badge-topspot";
          break;

        case "showcase":
          return "badge-showcase";
          break;

        case "hyc":
          return "badge-hyc";
          break;

        default:
          return "badge-other";
          break;
      }
    },
    getProductCaption(data) {
      return data.caption + " (" + data.used + "/" + data.available + ")";
    },
    getOptionsProductList(data, select, type) {
      if (type) {
        return (
          data.filter(item => item.id_pe == select.id_pe).length > 0 ||
          select.used >= select.available
        );
      } else {
        return data.filter(item => item.id_pe == select.id_pe).length
          ? "(Asignado)"
          : select.used >= select.available
          ? "(No disponible)"
          : "";
      }
    },
    setSearch(active) {
      let _self = this;
      if (!active) {
        _self.filters.search = "";
        _self.filters.selected.dealer.ads = _self.filters.selected.ads;
        return false;
      }
      if (_self.filters.search.trim().length == 0) {
        _self.filters.selected.dealer.ads = _self.filters.selected.ads;
        return false;
      }
      _self.filters.selected.dealer.ads = [
        ..._self.filters.selected.ads.filter(
          item => item.id.toString().trim() == _self.filters.search.trim()
        )
      ];
    }
  }
};
</script>
<style lang="scss">
.badge.badge--product {
  color: #222;
  background: transparent;
  text-transform: capitalize;
  font-size: 10px;
  font-weight: normal;
  display: block;
  margin: 0 0 3px;
  background: transparent;
  border: 1px solid #eee;
  white-space: nowrap;
  max-width: 100px;
  margin: 0 0 2px;
  overflow: hidden;
  white-space: normal;
}

.badge.badge--product.badge-topspot {
  color: #009688;
  border-color: #009688;
}

.badge.badge--product.badge-showcase {
  color: #3f51b5;
  border-color: #3f51b5;
}

.badge.badge--product.badge-hyc {
  color: #ff5722;
  border-color: #ff5722;
}
.badge.badge--product.badge-other {
  color: #555;
  border-color: #555;
}
</style>